<template>
  <w-page layout="error" :aria-label="i18n.gettext('Error')">
    <w-menu-error v-if="isMenuError" :message="message"></w-menu-error>
    <w-generic-error v-else :message="message"></w-generic-error>
  </w-page>
</template>

<script>
import { mapState } from 'vuex';

import i18n from '../../i18n';
import { MissingMenuError, MenuNotPublishedError } from '../../errors';

import Page from '../Page';

import MenuError from './MenuError';
import GenericError from './GenericError';

export default {
  data() {
    return {
      i18n,
    };
  },
  computed: {
    ...mapState(['error']),
    message() {
      return this.error.message;
    },
    isMenuError() {
      return (
        this.error instanceof MissingMenuError ||
        this.error instanceof MenuNotPublishedError
      );
    },
  },
  components: {
    'w-page': Page,
    'w-menu-error': MenuError,
    'w-generic-error': GenericError,
  },
};
</script>
